import { DocumentTextIcon } from '@heroicons/react/outline';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var EmptyDataView = function EmptyDataView(props) {
  var className = props.className,
      _props$label = props.label,
      label = _props$label === void 0 ? 'No data' : _props$label;
  return /*#__PURE__*/_jsx("div", {
    className: clsx('flex h-full w-full items-center justify-center', className),
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col items-center",
      children: [/*#__PURE__*/_jsx(DocumentTextIcon, {
        className: "h-8 w-8"
      }), /*#__PURE__*/_jsx("p", {
        className: "text-center",
        children: label
      })]
    })
  });
};